import React from 'react';
import { linkifyText } from '../../../utils/linkifyText';

/**
 * Plain text with its web addresses made clickable — the body of a message from
 * the team. React escapes every text segment, so markup in a message is shown,
 * never run; only http(s) addresses become links, and they open a new tab.
 */
export function LinkifiedText({ text }: { text: string }) {
  return (
    <>
      {linkifyText(text).map((segment, i) =>
        segment.type === 'link' ? (
          <a
            key={i}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2 break-all"
          >
            {segment.text}
          </a>
        ) : (
          <React.Fragment key={i}>{segment.text}</React.Fragment>
        ),
      )}
    </>
  );
}
